export enum Punctuation {
  POINT = '.',
  COMMA = ',',
}
